module.exports = __webpack_public_path__ + "f4e048d0dbe2b977dc674b5f7acfa67d.pdf";